import fr_FR from '../../date-picker/locale/fr_FR';
export default fr_FR;



// WEBPACK FOOTER //
// ./components/calendar/locale/fr_FR.tsx